import React from 'react';
import styles from './Footer.module.scss';
import { ContactForm } from '../ContactForm/ContactForm';

export const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>

        {/* Левая часть: Инфо и Контакты */}
        <div className={styles.infoSection}>
          <div className={styles.column}>
            <h4 className={styles.colTitle}>Полезное</h4>
            <nav className={styles.navLinks}>
              <a href="#examples" className={styles.link}>Примеры работ</a>
              <a href="#why" className={styles.link}>Зачем делать обработку?</a>
              <a href="#pricing" className={styles.link}>Про тарифы</a>
              <a href="#process" className={styles.link}>Процесс работы</a>
            </nav>
          </div>

          <div className={styles.column}>
            <h4 className={styles.colTitle}>Контакты</h4>
            <div className={styles.contactsList}>
              <a href="mailto:visionaparts@yandex.ru" className={styles.link}>visionaparts@yandex.ru</a>
              <a href="tel:+78199195005" className={styles.link}>+78199195005</a>
              <a href="https://t.me/visionaparts" target="_blank" rel="noreferrer" className={styles.link}>tg: @visionaparts</a>
            </div>

            <div className={styles.socials}>
              {/* Иконка Telegram */}
              <a href="https://t.me/visionaparts" className={styles.socialIcon} aria-label="Telegram">
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69.01-.03.01-.14-.07-.19-.08-.05-.19-.02-.27 0-.12.03-1.98 1.25-5.58 3.68-.53.36-1.01.54-1.44.53-.47-.01-1.38-.27-2.06-.49-.83-.27-1.49-.42-1.43-.88.03-.24.38-.49 1.05-.75 4.12-1.79 6.87-2.93 8.24-3.5 3.92-1.63 4.73-1.92 5.26-1.93.12 0 .38.03.53.15.13.1.17.24.18.34.01.07.01.16 0 .26z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Правая часть: Наш новый компонент Формы */}
        <div className={styles.formSection}>
          <ContactForm />
        </div>

      </div>
    </footer>
  );
};